import React, { FC, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../Components/Table6/Table6";
import { Button } from "reactstrap";

import { initReactI18next, useTranslation } from "react-i18next";
import moment from "moment/moment";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { toNumber } from "config/util";

import { useState } from "react";

const App = ({
  dispatch_put_markets_exchanges_id_cancel,
  searchHistoriesTransactions,
  set_searchHistoriesTransactions,
  set_modalHistoriesTransactions,
  set_alert,
  searchUsers,
  data_tables,
  inLoading,
}) => {
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);

  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });
  const classes = useStyles();
  return (
    <>
      <TableContainer component={Paper}>
        <Table className="table-striped" aria-label="a dense table">
          <TableHead>
            <TableRow style={{ whiteSpace: "nowrap" }}>
              <TableCell align="left">{t("実行日時")}</TableCell>
              <TableCell align="center">{t("コイン")}</TableCell>
              <TableCell align="center">{t("タイプ")}</TableCell>
              <TableCell align="right">{t("数量")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data_tables.map((prop, idx) => {
              const props = {
                id: prop.order_id,

                coin: prop.coin,
                amount: prop.amount,
                executed_at: prop.executed_at,
                executed_at_label: prop.executed_at
                  ? moment
                      .utc(prop.executed_at)
                      .local()
                      .format("YY/MM/DD HH:mm")
                  : "",
                type_label: maps.history_types[prop.type],
              };
              let sign = "";

              switch (prop.type) {
                case 1:
                  //  "入金";
                  sign = "+ ";
                  break;
                case 2:
                  //  "出金";
                  sign = "− ";
                  break;
                case 3:
                  //  "オーダー (入金)";
                  sign = "+ ";
                  break;
                case 4:
                  //  "オーダー (出金)";
                  sign = "− ";
                  break;
                case 5:
                  //  "交換 (入金)";
                  sign = "+ ";
                  break;
                case 6:
                  //  "交換 (出金)";
                  sign = "− ";
                  break;
                case 7:
                  //  "送金 (入金)";
                  sign = "+ ";
                  break;
                case 8:
                  //  "送金 (出金)";
                  sign = "− ";
                  break;
                case 9:
                  //  "送金手数料 (入金)";
                  sign = "− ";
                  break;
                case 10:
                  //  "送金手数料 (出金)";
                  sign = "− ";
                  break;
                case 11:
                  //  "システム利用料";
                  sign = "− ";
                  break;
                case 12:
                  //  "システム利用料";
                  sign = "− ";
                  break;
                case 13:
                  //  "アフェリエイト報酬";
                  sign = "+ ";
                  break;
                  case 14:
                    //  "ステーキング報酬";
                    sign = "+ ";
                    break;
                    case 15:
                      //  "ステーキング";
                      sign = "- ";
                      break;
              }
              return (
                <TableRow key={idx} style={{ whiteSpace: "nowrap" }}>
                  <TableCell align="left">{props.executed_at_label}</TableCell>
                  <TableCell align="center">{props.coin}</TableCell>
                  <TableCell align="center">{t(props.type_label)}</TableCell>
                  <TableCell align="right">
                    <span
                      style={{ color: sign === "+ " ? "#3BB54A" : "#E21B1B" }}
                    >
                      {sign}
                      {/* {toNumber(props.amount,maps.coin_decimals[props.coin].price)} */}
                      {toNumber(props.amount, 20)}
                    </span>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default App;
